import { PAYMENT_OPTIONS, PAYMENT_TYPE_OPTIONS } from '../constant/constants';
import { DeviceColumns } from '../enum/DeviceColumns';
import { PaymentTypeColumn } from '../enum/PaymentType';

/**
 * Checks whether a value matches the provided search term.
 *
 * For `DeviceTypeEnum` and  `PaymentTypeEnum` fields, the numeric value is converted
 * to its display name using PAYMENT_OPTIONS or PAYMENT_TYPE_OPTIONS before comparison
 * (e.g. 1 -> "OTC").
 *
 * @param value - Value to search against.
 * @param term - Normalized search term.
 * @param field - Optional field name used for special mappings.
 * @returns True if the value matches the search term.
 */

export const matchesSearch = (value: string | number | null, term: string, field?: string) => {
  if (value === null || value === undefined) {
    return false;
  }

  let searchableValue = value;

  if (field === DeviceColumns.DEVICE_TYPE_ENUM) {
    searchableValue = PAYMENT_OPTIONS.find((option) => option.ID === Number(value))?.Name ?? value;
  }

  if (field === PaymentTypeColumn.PAYMENT_TYPE) {
    searchableValue = PAYMENT_TYPE_OPTIONS.find((option) => option.ID === Number(value))?.Name ?? value;
  }

  return searchableValue.toString().toLowerCase().includes(term);
};
